import { toast } from 'sonner';

export type SessionEndReason = 'expired' | 'inactivity';

const SESSION_END_MESSAGES: Record<SessionEndReason, string> = {
  expired: 'Session expired. Please login again.',
  inactivity: 'Signed out due to inactivity. Please login again.',
};

const AUTH_STORAGE_KEYS = [
  'auth_token',
  'refresh_token',
  'user',
  'user_profile',
  'permissions',
  'last_activity_at',
];

let sessionEnding = false;

export const isSessionEnding = (): boolean => sessionEnding;

export const clearAuthStorage = (): void => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

const expireCookies = (): void => {
  document.cookie.split(';').forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
};

export const endSession = (reason: SessionEndReason): void => {
  if (sessionEnding) {
    return;
  }

  if (window.location.pathname === '/login') {
    clearAuthStorage();
    return;
  }

  sessionEnding = true;
  clearAuthStorage();
  sessionStorage.clear();
  expireCookies();

  toast.error(SESSION_END_MESSAGES[reason]);
  window.location.replace(`/login?reason=${reason}`);
};

export const getSessionEndMessage = (reason: string | null): string | null => {
  if (reason === 'expired' || reason === 'inactivity') {
    return SESSION_END_MESSAGES[reason];
  }
  return null;
};

export const getAccessTokenSecondsRemaining = (): number | null => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    return null;
  }

  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    const padded = parts[1] + '='.repeat((4 - (parts[1].length % 4)) % 4);
    const payload = JSON.parse(atob(padded)) as { exp?: number };
    if (typeof payload.exp !== 'number') {
      return null;
    }
    return payload.exp - Math.floor(Date.now() / 1000);
  } catch {
    return null;
  }
};
